import { hardRedirectTo } from '../../../utils';
import type { ServiceFilter } from '../../../types';

/**
 * Redirect to the GitHub app installation URL.
 */
export const redirectToGithubAppInstallation = () => {
  hardRedirectTo('/api/services/github-app/installation-url');
};

/**
 * Determine if the GitHub App is installed.
 * @returns 'installed' if the GitHub App is installed, 'missing' if it is not, and 'unknown' if it cannot be determined.
 */
export function hasGithubAppInstallation({
  isGithubApp,
  filters,
}: {
  isGithubApp: boolean;
  filters: ServiceFilter[];
}): 'installed' | 'missing' | 'unknown' {
  if (!isGithubApp) {
    return 'unknown';
  }
  return filters.length > 0 ? 'installed' : 'missing';
}
